module.exports = __webpack_public_path__ + "static/goblin-61d92358796e12939a8da27012704b3b.jpg";